<template>
  <div
    id="sidebar"
    :class="{ open: props.isOpen }"
  >
    <slot />
  </div>
  <div
    id="overlay"
    aria-hidden="true"
    @click="emit('close')"
  />
</template>

<script setup lang="ts">
import { useHeaderHeight } from '@shared/composables/useHeaderHeight';
import { computed } from 'vue';

const emit = defineEmits(['close']);
const props = defineProps<{
  width?: number;
  isOpen: boolean;
}>();

const headerHeight = useHeaderHeight();

const sidebarWidth = computed(() => {
  if (props.width) {
    return `${props.width}px`;
  }
  return '250px';
});
</script>

<style lang="scss" scoped>
$header-height: v-bind(headerHeight);
$sidebar-width: v-bind(sidebarWidth);

#sidebar {
  display: none;
  padding: 1.75rem 1rem;
  background-color: white;
  width: $sidebar-width;
  z-index: 100;
  @media screen and (max-width: 991px) {
    display: block;
    position: fixed;
    top: $header-height;
    right: -100%;
    height: calc(100vh - $header-height);
    border-right: 1px solid var(--bs-light-gray);
    transition: right 300ms ease-in-out;
    &.open {
      right: 0;
      + #overlay {
        display: block;
      }
    }
  }
}

#overlay {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: $header-height;
  left: 0;
  height: calc(100vh - $header-height);
  width: 100%;
  z-index: 99;
  display: none;
}
</style>
